{
    "PaginatedList_Search": "Ricerca",
    "PaginatedList_Search_NoResults": "Non sono state trovate estensioni corrispondenti alla ricerca",
    "NAME": "PaginatedList"
}